import * as THREE from 'three';
import { gsap } from "gsap";
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { RGBELoader } from 'three/addons/loaders/RGBELoader.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';

function initHome() {


    // stops scene from propagating if component is being replaced by another
    Livewire.on('activate-component', () => {
        cancelAnimationFrame(animationId)
        camera.position.set(0, 0, 8);
    })

    Livewire.on('init-gsap', () => {

        let homeTextTimeline = gsap.timeline({ repeat: 0 });

        homeTextTimeline.to('.content-container', {
            y: '81.65%',
            duration: 1,
            ease: "power3.inOut",
        }, 0)

        homeTextTimeline.to('.content-container', {
            y: '54.4%',
            duration: 1,
            ease: "power3.inOut",
        }, 1.15)

        homeTextTimeline.to('.content-container', {
            y: '27%',
            duration: 1,
            ease: "power3.inOut",
        }, 2.3)

        homeTextTimeline.to('.content-container', {
            y: '0%',
            duration: 1,
            ease: "power3.inOut",
        }, 3.45)
    })
}

export {
    initHome
}

